import { createSlice } from '@reduxjs/toolkit';

import { TaskType } from 'utils/TaskAPI';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface TaskState {
    tasks: Array<TaskType> | null
}

const initialState: TaskState = {
    tasks: null,
};

export const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
        setTasks: (state, action: PayloadAction<TaskType[]>) => {
            state.tasks = action.payload;
        },
    },
});

export const { setTasks } = taskSlice.actions;

export default taskSlice.reducer;